import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { PackagePlus, ChevronDown, ChevronUp } from "lucide-react";

// Chest creation lives here; the full item-card library/editor moved to the Items tab. This tab
// now also lists every chest across the WHOLE game (not just the current map) so the GM can check
// what's in one — and where it is — without hunting between scenes.
function ChestRow({ chest, sceneName }) {
  const [open, setOpen] = useState(false);
  const loot = chest.loot || [];
  return (
    <div data-testid={`gm-chest-row-${chest.id}`} className="bg-black/20 border border-white/10 rounded-lg overflow-hidden">
      <button data-testid={`gm-chest-toggle-${chest.id}`} onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-2.5 py-2 text-left">
        <div>
          <p className="text-xs text-[#D4AF37]">{chest.name}</p>
          <p className="text-[9px] text-[#f1e0c5]/40 uppercase tracking-wider">{sceneName || "Unknown Map"} · {loot.length} item{loot.length === 1 ? "" : "s"}</p>
        </div>
        {open ? <ChevronUp className="w-3.5 h-3.5 text-[#f1e0c5]/40" /> : <ChevronDown className="w-3.5 h-3.5 text-[#f1e0c5]/40" />}
      </button>
      {open && (
        <div className="px-2.5 pb-2 space-y-1">
          {loot.length > 0 ? loot.map((item, i) => (
            <p key={i} className="text-[10px] text-[#f1e0c5]/60">• {item.name} {item.price_amount > 0 && <span className="text-[#f1e0c5]/30">({item.price_amount}{item.price_currency || "gp"})</span>}</p>
          )) : <p className="text-[10px] text-[#f1e0c5]/30 italic">Empty — add loot from the Items tab.</p>}
        </div>
      )}
    </div>
  );
}

export default function GmRewardsTab({ game, onSpawnToken }) {
  const [chests, setChests] = useState([]);

  useEffect(() => {
    api.get(`/games/${game.id}/tokens/chests`).then((r) => setChests(r.data)).catch(() => setChests([]));
  }, [game.id]);

  const sceneNameFor = (t) => (game.scenes || []).find((s) => s.id === t.scene_id)?.name;

  const createChest = async () => {
    await onSpawnToken({ name: "Treasure Chest", token_type: "chest", loot: [], image_url: "/api/uploads/starter-image-treasure-chest" });
    setTimeout(() => api.get(`/games/${game.id}/tokens/chests`).then((r) => setChests(r.data)), 400);
  };

  return (
    <div className="space-y-4">
      <Button data-testid="gm-create-chest-button" onClick={createChest} size="sm" className="w-full rounded-full gap-2 bg-[#D90429] hover:bg-[#b8031f]">
        <PackagePlus className="w-3.5 h-3.5" /> Create a Treasure Chest
      </Button>
      <p className="text-[10px] text-[#f1e0c5]/30">Stock chests, NPCs, shops, or a player's inventory directly from the Items tab.</p>

      <div className="border-t border-white/10 pt-3 space-y-1.5">
        <p className="text-[10px] uppercase text-[#f1e0c5]/40">Chests Across This Game ({chests.length})</p>
        {chests.map((c) => <ChestRow key={c.id} chest={c} sceneName={sceneNameFor(c)} />)}
        {chests.length === 0 && <p className="text-xs text-[#f1e0c5]/30 italic">No chests created yet.</p>}
      </div>
    </div>
  );
}
